export default __webpack_public_path__ + "static/media/office1-before2-480w.41077263.webp";